/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chatreviewingcase2Inputs */

const en_chatreviewingcase2 = /** @type {(inputs: Chatreviewingcase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reviewing your case…`)
};

const pt_chatreviewingcase2 = /** @type {(inputs: Chatreviewingcase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A rever o teu caso…`)
};

/**
* | output |
* | --- |
* | "Reviewing your case…" |
*
* @param {Chatreviewingcase2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const chatreviewingcase2 = /** @type {((inputs?: Chatreviewingcase2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chatreviewingcase2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chatreviewingcase2(inputs)
	return pt_chatreviewingcase2(inputs)
});
export { chatreviewingcase2 as "chatReviewingCase" }